import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Star from '@components/Images/Star';
import { formatAverageRating } from '@utils/profileTemplatesUtils';
import s from './AverageRating.module.scss';

interface AverageRatingProps {
  averageRating: number;
  templatesLength: number;
  isMobileView?: boolean;
}

const AverageRating: React.FC<AverageRatingProps> = ({
  averageRating,
  templatesLength,
  isMobileView,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  if (averageRating <= 0 || templatesLength <= 1) return null;

  return (
    <Box className={s.averageRatingContainer} verticalAlign="middle" gap="6px">
      <Box verticalAlign="middle" gap="3px">
        <Star
          className={s.star}
          width="18px"
          height="18px"
          viewBox="0 4 18 18"
        />
        <Heading
          as="h3"
          size={isMobileView ? 'tiny' : 'small'}
          className={s.averageRating}
          dataHook="average-rating-title"
        >
          {formatAverageRating(averageRating, language)}
        </Heading>
      </Box>
      <Heading
        as="h3"
        size={isMobileView ? 'tiny' : 'small'}
        className={s.templatesLength}
        dataHook="templates-length"
      >
        ({templatesLength})
      </Heading>
    </Box>
  );
};

export default AverageRating;
